import React, { useCallback, useState, useMemo } from 'react';
import {
  PlayerStatistics,
  IPlayerStatistics as IPlayerStatisticsDs,
} from '@sky-it-livedata/livedata-sports-design-system';
import { playerStatisticsWidget, IPlayerStatistics } from '@sky-it-livedata/livedata-live-match-pages-widgets';

import { IModelWrapper } from '../../typings/common-types';
import { useService } from '../hooks/useService';
import { isEmptyObject, getModelFromUseService } from '../../utils/props-validator';

export interface IPlayerStatisticsWrapper extends IModelWrapper<IPlayerStatistics> {}

const PlayerStatisticsDetailWrapper = ({ query, initialModel, live }: IPlayerStatisticsWrapper) => {
  const [dropdownIndex, setDropdownIndex] = useState(0);

  const onDropDownChange = useCallback(
    (dropdownIndex: number) => {
      setDropdownIndex(dropdownIndex);
    },
    [setDropdownIndex]
  );

  const { model } = useService({
    live,
    query,
    widget: playerStatisticsWidget,
    initialValue: initialModel,
  });
  const componentModel: IPlayerStatistics = useMemo(() => getModelFromUseService(model), [model]);

  const componentMapped: IPlayerStatisticsDs | null = useMemo(() => {
    if (!isEmptyObject(componentModel)) {
      return {
        ...componentModel,
        dropdown: {
          ...componentModel.dropdown,
          links: componentModel.dropdown.links.map((link, index) =>
            index === dropdownIndex ? { ...link, isSelected: true } : { ...link, isSelected: false }
          ),
          onClick: (_: React.MouseEvent, id: number) => onDropDownChange(id),
        },
        items: componentModel.statistics?.find((_, index: number) => index === dropdownIndex)?.items || [],
      };
    }

    return null;
  }, [componentModel, dropdownIndex, onDropDownChange]);

  return componentMapped && !isEmptyObject(componentMapped) ? (
    <div>{<PlayerStatistics {...componentMapped} />}</div>
  ) : null;
};

export default PlayerStatisticsDetailWrapper;
